// Преглед на снимка на цял екран с увеличение.
// Отваря се отвсякъде с showPhoto(url). Затваря се с ✕, с бутона „Затвори“
// или при докосване извън снимката. + / − за мащаб.

import React, { useEffect, useState } from 'react';
import { Image, Modal, Pressable, ScrollView, Text, useWindowDimensions, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { t } from './i18n';

let show: ((url: string) => void) | null = null;
export const showPhoto = (url: string) => show?.(url);

function RoundButton({ label, onPress }: { label: string; onPress: () => void }) {
  return (
    <Pressable
      onPress={onPress}
      hitSlop={10}
      style={{
        width: 46,
        height: 46,
        borderRadius: 23,
        backgroundColor: 'rgba(255,255,255,0.22)',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Text style={{ color: '#fff', fontSize: 22, fontWeight: '700' }}>{label}</Text>
    </Pressable>
  );
}

export function PhotoViewerHost() {
  const [url, setUrl] = useState<string | null>(null);
  const [scale, setScale] = useState(1);
  const { width, height } = useWindowDimensions();
  const insets = useSafeAreaInsets();

  useEffect(() => {
    show = (u) => {
      setUrl(u);
      setScale(1);
    };
    return () => {
      show = null;
    };
  }, []);

  if (!url) return null;
  const close = () => setUrl(null);

  // Пространството за снимката: целият екран без горната лента с бутони
  // и без долния бутон „Затвори“ — така при мащаб 1 нищо не се реже.
  const fitWidth = width;
  const fitHeight = height - (insets.top + 62) - (insets.bottom + 90);

  return (
    <Modal visible transparent animationType="fade" onRequestClose={close}>
      {/* Докосване по фона (извън снимката) затваря */}
      <Pressable onPress={close} style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.94)' }}>
        {/* Лента с бутони — под notch-а */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: 10,
            paddingHorizontal: 14,
            paddingTop: insets.top + 8,
            paddingBottom: 8,
            zIndex: 10,
          }}
        >
          <RoundButton label="−" onPress={() => setScale((s) => Math.max(1, s - 0.5))} />
          <RoundButton label="+" onPress={() => setScale((s) => Math.min(5, s + 0.5))} />
          <RoundButton label="✕" onPress={close} />
        </View>

        {/* ЕДИН ScrollView — вложен втори (хоризонтален) прехваща жеста
            и увеличаването с два пръста спира да работи. Един скрол зумва
            с пръсти И се движи в двете посоки, когато снимката е увеличена.
            Бутоните + / − остават като резерва (на Android ScrollView
            не поддържа увеличаване с пръсти). */}
        <ScrollView
          maximumZoomScale={5}
          minimumZoomScale={1}
          bouncesZoom
          centerContent
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{
            flexGrow: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {/* Докосване по самата снимка НЕ затваря прегледа */}
          <Pressable onPress={() => {}}>
            <Image
              source={{ uri: url }}
              style={{ width: fitWidth * scale, height: fitHeight * scale }}
              resizeMode="contain"
            />
          </Pressable>
        </ScrollView>

        <Pressable
          onPress={close}
          style={{
            position: 'absolute',
            bottom: insets.bottom + 20,
            alignSelf: 'center',
            backgroundColor: 'rgba(255,255,255,0.2)',
            borderRadius: 24,
            paddingVertical: 12,
            paddingHorizontal: 32,
          }}
        >
          <Text style={{ color: '#fff', fontWeight: '600', fontSize: 16 }}>{t('Затвори')}</Text>
        </Pressable>
      </Pressable>
    </Modal>
  );
}
